// useLoader.ts 
import { useState, useEffect } from "react";


class LoaderManager {
  private listeners: ((value: boolean) => void)[] = [];
  private currentState = false;

  setLoader(value: boolean) {
   
    this.currentState = value;
    this.listeners.forEach(listener => {
     
      listener(value);
    });
  }

  subscribe(listener: (value: boolean) => void) {
   
    this.listeners.push(listener);
    // Immediately call with current state
    listener(this.currentState);
    
    // Return unsubscribe function
    return () => {
      const index = this.listeners.indexOf(listener);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  getCurrentState() {
    return this.currentState;
  }
}

const loaderManager = new LoaderManager();

export const useLoader = () => {
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const unsubscribe = loaderManager.subscribe(setLoader);
    return unsubscribe;
  }, []);

  return loader;
};

export const setGlobalLoader = (value: boolean) => {

  loaderManager.setLoader(value);
};